import { useEffect } from 'react';

import { EventFnReturn } from './common';
import { useSocketIO } from './provider';

export const useSocketEvent = (fn: EventFnReturn) => {
  const { io } = useSocketIO();

  useEffect(() => fn(io), [io, fn]);
};

export const useSocketSubscribe = <B>({
  unsubscribe,
  subscribe,
  body,
}: {
  subscribe: string;
  unsubscribe: string;
  body: B;
}) => {
  const { io } = useSocketIO();

  useEffect(() => {
    io.emit(subscribe, body);

    return () => {
      io.emit(unsubscribe, body);
    };
  }, [io, body, subscribe, unsubscribe]);
};
